import { createContext } from 'react';
import { RegistrationsContextType } from './contextType';
import {Device} from "../types/device";

const initialState: RegistrationsContextType = {
  config: {
    installationConfig: null,
    fetchInstallationConfig: () => {},
    isLoading: false
  },
  devices: {
    fetchDevices: (): Promise<Device[] | void> => Promise.resolve(),
    devices: [],
    isDevicesLoading: false,
    removeDevice: () => {},
    resetDevices: () => {}
  },
  registrations: {
    isRegistrationsLoading: false,
    registrationsError: false,
    activeRegistration: null,
    completedRegistrationsMetaData: [],
    isLoadingCompletedRegistrationsMetaData: false,
    registrations: [],
    registrationsHasBeenFetched: false,
    completedHasBeenFetched: false,
    hasLoadedAnyCompletedRegistrationsMetaData: false,
    updateCustomer: () => new Promise(() => {}),
    updateLocation: () => new Promise(() => {}),
    updateSystemDescription: () => new Promise(() => {}),
    updateDevices: () => new Promise(() => {}),
    setActiveRegistration: () => {},
    fetchAllRegistrations: () => new Promise(() => {}),
    fetchRegistration: () => new Promise(() => {}),
    completeRegistration: () => new Promise(() => {}),
    createRegistration: () => new Promise(() => {}),
    deleteRegistrationAction: () => new Promise(() => {}),
    reopenCompletedRegistrationAction: () => new Promise(() => {}),
    fetchAllCompletedRegistrationsMetaData: () => new Promise(() => {}),
    removeActiveRegistration: () => {},
    resetRegistrations: () => {}
  }
};

export const RegistrationsContext = createContext<RegistrationsContextType>(initialState);
